import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="px-5 pb-20 md:pb-28" data-id="element-95" data-mp="1o46konudlsx5">
      <div className="mx-auto flex max-w-3xl flex-col items-center gap-6 border-y border-ink-line py-12 text-center md:flex-row md:text-left" data-id="element-96" data-mp="1o33y2s436cn1">
        <div className="flex h-24 w-24 shrink-0 flex-col items-center justify-center rounded-full border-2 border-gold text-gold" data-id="element-97" data-mp="1x4l93w2mzo4v">
          <ShieldCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-98" data-mp="19fsj0g8p4ai6" />
          <span className="font-display text-xl leading-none" data-id="element-99" data-mp="14fxu2i8hduzr">10 J</span>
        </div>
        <div data-id="element-100" data-mp="1j4k5w9ywg4m8">
          <h2 className="font-serif text-2xl font-semibold text-cream" data-id="element-101" data-mp="1j4aj0v95idkr">Garantie satisfait ou remboursé de 10 jours</h2>
          <p className="mt-2 leading-relaxed text-cream-muted" data-id="element-102" data-mp="1edkdni0q6aq2">
            Essayez le pack pendant 10 jours avec vos élèves. S’il ne vous fait pas gagner des heures de préparation,
            envoyez-nous un simple e-mail et nous vous remboursons intégralement. Sans question.
          </p>
        </div>
      </div>
    </section>;
}